import styled from "styled-components";
import { Box, darken } from "@mui/material";
import { TemplateColorObject } from "../../../../../InvitationColorMatrix";

const EASE = "cubic-bezier(0.22, 1, 0.36, 1)";

export const NamesEntranceWrapper = styled(Box)<{ colormatrix: TemplateColorObject }>`
	position: absolute;
	z-index: 3;
	width: 100%;
	max-width: 430px;
	height: 100vh;
	overflow: hidden;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: opacity 1.1s ease-in-out 1.1s;
	background: ${props => props.colormatrix.entrance.background};

	&.show {
		opacity: 1;
		cursor: pointer;
	}

	&.hide {
		opacity: 0;
		z-index: -1;
		cursor: unset;
	}

	&.preview {
		position: relative;
		max-width: 320px;
		height: 600px;
		border-radius: 16px;
		margin: 0 auto;
		cursor: default;
	}

	.couples_banner {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 6px;
		max-width: 320px;
		padding: 0 24px;
		text-align: center;

		p {
			text-align: center;
			color: ${props => darken(props.colormatrix.entrance.envelope_background, 0.55)};
			opacity: 0;
		}

		.wedding_of {
			font-family: var(--roboto), sans-serif;
			font-size: 16px;
			letter-spacing: 3px;
			animation: names_in_up 1s ${EASE} 0.3s forwards;
		}
		.couples {
			font-family: var(--inriaSerif), sans-serif;
			font-size: 38px;
			line-height: 1.15;
		}
		.groom {
			animation: names_in_start 1.1s ${EASE} 0.7s forwards;
		}
		.and {
			font-size: 24px;
			animation: names_in_pop 0.9s cubic-bezier(0.34, 1.56, 0.64, 1) 1.1s forwards;
		}
		.bride {
			animation: names_in_end 1.1s ${EASE} 1.4s forwards;
		}
	}

	/* Exit: the names part and drift away before the invitation is revealed. */
	&.opened .wedding_of {
		animation: names_out_up 0.7s ease-in forwards;
	}
	&.opened .groom {
		animation: names_out_start 0.9s ease-in forwards;
	}
	&.opened .and {
		animation: names_out_pop 0.6s ease-in forwards;
	}
	&.opened .bride {
		animation: names_out_end 0.9s ease-in forwards;
	}

	.tab_continue_container {
		position: absolute;
		bottom: 8%;
		left: 0;
		right: 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 15px;

		.tab_continue {
			background: rgba(255, 255, 255, 0.85);
			box-shadow: 0 0 8px 1px ${props => darken(props.colormatrix.entrance.envelope_background, 0.3)};
			border-radius: 50px;
			padding: 20px;

			svg {
				fill: ${props => darken(props.colormatrix.entrance.envelope_background, 0.4)};
			}
		}

		.tab_continue_text {
			font-family: var(--poppins), sans-serif;
			font-weight: bold;
			color: ${props => darken(props.colormatrix.entrance.envelope_background, 0.5)};
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.couples_banner p {
			animation-duration: 0.01s !important;
			animation-delay: 0s !important;
		}
	}

	@keyframes names_in_up {
		from {
			opacity: 0;
			transform: translateY(-12px);
			letter-spacing: 8px;
		}
		to {
			opacity: 1;
			transform: none;
			letter-spacing: 3px;
		}
	}
	@keyframes names_in_start {
		from {
			opacity: 0;
			transform: translateX(-40px);
			filter: blur(6px);
		}
		to {
			opacity: 1;
			transform: none;
			filter: blur(0);
		}
	}
	@keyframes names_in_end {
		from {
			opacity: 0;
			transform: translateX(40px);
			filter: blur(6px);
		}
		to {
			opacity: 1;
			transform: none;
			filter: blur(0);
		}
	}
	@keyframes names_in_pop {
		from {
			opacity: 0;
			transform: scale(0.2) rotate(-20deg);
		}
		to {
			opacity: 1;
			transform: none;
		}
	}
	@keyframes names_out_up {
		from {
			opacity: 1;
			transform: none;
		}
		to {
			opacity: 0;
			transform: translateY(-16px);
		}
	}
	@keyframes names_out_start {
		from {
			opacity: 1;
			transform: none;
			filter: blur(0);
		}
		to {
			opacity: 0;
			transform: translateX(-60px) scale(0.92);
			filter: blur(8px);
		}
	}
	@keyframes names_out_end {
		from {
			opacity: 1;
			transform: none;
			filter: blur(0);
		}
		to {
			opacity: 0;
			transform: translateX(60px) scale(0.92);
			filter: blur(8px);
		}
	}
	@keyframes names_out_pop {
		from {
			opacity: 1;
			transform: none;
		}
		to {
			opacity: 0;
			transform: scale(0.2) rotate(20deg);
		}
	}
`;
